import { render, staticRenderFns } from "./SoftwareLicenceModal.vue?vue&type=template&id=69b80eb0&"
import script from "./SoftwareLicenceModal.vue?vue&type=script&lang=js&"
export * from "./SoftwareLicenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports